import { render, staticRenderFns } from "./template/moorage-payment.html?vue&type=template&id=5510631c&scoped=true&external"
import script from "./MooragePayment.vue?vue&type=script&lang=js"
export * from "./MooragePayment.vue?vue&type=script&lang=js"
import style0 from "./MooragePayment.vue?vue&type=style&index=0&id=5510631c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510631c",
  null
  
)

export default component.exports